<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Geography
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>Where would you like to target your advertising campaign?</span>
          </v-tooltip>
        </h1>
        <v-radio-group v-model="selectedGeo">
          <v-radio
            v-for="(geo, index) in geos"
            :key="index"
            :label="geo.name"
            :value="geo.value"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="6">
        <geo-add-saved-location
          :dialog="dialog"
          :locations="geoLocations"
          @closeDialog="dialog = false"
        />
        <v-select
          v-if="selectedGeo === 'zips'"
          v-model="selectedLocations"
          :items="locations"
          item-text="data.name"
          item-value="data.locations"
          class="mt-2"
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-btn
          v-if="selectedGeo === 'zips'"
          @click="dialog = true"
          color="primary"
        >
          Add Saved Location
        </v-btn>
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
        <v-btn @click="previousPage">Previous</v-btn>
        <v-spacer />
        <v-btn
          @click="nextPage"
          color="primary"
        >Next
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Adcreatives from '../../../facebook/Adcreatives'
  import GeoAddSavedLocation from './GeoAddSavedLocation'
  import states from '../../../../static/states'
  import lodash from 'lodash'

  export default {
    name: 'campaign-geo',
    components: {
      GeoAddSavedLocation
    },
    data () {
      return {
        geos: [],
        selectedGeo: 'countries',
        next: true,
        selectedLocations: null,
        dialog: false
      }
    },
    mounted () {
      this.createInitialGeo()
      // Note: check if geolocations already exists
      if (this.campaign.targeting && this.campaign.targeting.geo_locations) {
        this.selectedGeo = Object.keys(this.campaign.targeting.geo_locations)[0]
      }
    },
    props: {
      campaign: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      geoLocations () {
        return this.campaign.targeting ? this.campaign.targeting.geo_locations : {}
      },
      locations () {
        return this.$store.getters.getLocations
      },
      zips () {
        if (!this.geoLocations || !this.geoLocations.zips) return null
        return this.geoLocations.zips.map(l => l.name)
      },
      advertisers () {
        return this.$store.getters.getAdvertisers
      },
      user () {
        return this.$store.getters.getCurrentUser
      },
      selectedAdvertiser () {
        return this.advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
      }
    },
    methods: {
      compareLocations () {
        if (!this.locations) return null
        const locations = lodash.cloneDeep(this.locations)
        locations.forEach(location => {
          const initialLocations = [...location.data.locations]
          const id = location.data.locations.sort().every((value, index) => { return value === this.zips.sort()[index] })
          if (id) this.selectedLocations = initialLocations
        })
      },
      createInitialGeo () {
        if (this.selectedAdvertiser.data.political.campaign_type === 'us_house') {
          this.$emit('setCampaignProperty', 'selectedGeo', 'electoral_districts')
          this.geos.push(
            {
              name: 'My district',
              value: 'electoral_districts'
            },
            {
              name: 'My state',
              value: 'regions'
            },
            {
              name: 'Nationwide',
              value: 'countries'
            },
            {
              name: 'Saved locations',
              value: 'zips'
            }
          )
          this.selectedGeo = 'electoral_districts'
        } else {
          this.$emit('setCampaignProperty', 'selectedGeo', 'regions')
          this.geos.push(
            {
              name: 'My state',
              value: 'regions'
            },
            {
              name: 'Nationwide',
              value: 'countries'
            },
            {
              name: 'Saved locations',
              value: 'zips'
            }
          )
          this.selectedGeo = 'regions'
        }
      },
      nextPage () {
        this.$emit('next')
      },
      previousPage () {
        this.$emit('previous')
      },
      searchByQuery (types, query) {
        const user = JSON.parse(localStorage.getItem('outfoxUser'))
        const params = {
          types: types,
          query: query
        }
        const facebook = new Adcreatives(user, params)
        return new Promise(resolve => {
          resolve(facebook.searchByQuery())
        })
          .then(res => res.data.data)
      }
    },
    watch: {
      zips: {
        handler (val) {
          if (val) this.compareLocations()
        },
        immediate: true
      },
      selectedGeo (val) {
        this.$emit('setCampaignProperty', 'selectedGeo', val)
        const state = this.selectedAdvertiser.data.political.state
        const district = this.selectedAdvertiser.data.political.district
        switch (val) {
          case 'countries':
            this.$emit('setGeoLocations', {
              countries: ['US']
            })
            break
          case 'regions':
            new Promise(resolve => resolve(this.searchByQuery(['region'], state)))
              .then(res => {
                const regionKey = res.find(i => i.name === state).key
                this.$emit('setGeoLocations', {
                  regions: [{key: regionKey}]
                })
              })
            break
          case 'electoral_districts':
            const abbr = states.find(s => s.name === state).abbreviation
            const key = `US:${abbr}${district > 9 ? district : 0 + district.toString()}`
            this.$emit('setGeoLocations', {
              electoral_districts: [{key}]
            })
        }
      },
      selectedLocations (val) {
        this.$emit('setGeoLocations', {
          zips: val.map(i => {
            return {key: `US:${i}`}
          })
        })
      }
    }
  }
</script>
